export default __webpack_public_path__ + "static/media/disable-white.27d5a1c4.svg";